import React, { Component } from 'react';
import Link from '../common/link';
import Logo from './logo';

class AppsNavigation extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            click: 'inactive',
        };
        this.timer = 0;
    }

    clickedMenu = () => {
        this.setState({
            click: this.state.click === 'inactive' ? 'active' : 'inactive',
        });
    };

    hideDropdown = () => {
        this.timer = setTimeout(() => {
            this.setState({ click: 'inactive' });
            this.timer = 0;
        }, 800);
    };

    cancelTimout = () => {
        clearTimeout(this.timer);
    };

    render() {
        let annualLink = window.location.hostname.includes('localhost') ? 'http://localhost:3001' : 'https://pcmh.evolutionaryhealthsolutions.com/annual';

        return (
            <div className={`Navbar__hamburger ${this.state.click}`} onClick={this.clickedMenu} onMouseLeave={this.hideDropdown} onMouseOver={this.cancelTimout}>
                <i className="fa fa-bar fa-bars bars"></i>
                <div className="dropdown" onMouseLeave={this.hideDropdown} onMouseOver={this.cancelTimout}>
                    <li>
                        <Link to={`${annualLink}`}>
                            <div className="Logo__hamburger">
                                <Logo />
                            </div>
                        </Link>
                    </li>
                </div>
            </div>
        );
    }
}

export default AppsNavigation;
